import { WindowMock } from "./WindowMock";
import { APP_ICONS } from "./appIcons";
import styles from "./Environment.module.css";

/**
 * The Environment — sells the "digital desk" feeling. Centered title +
 * lede above, three windows in a single row below. Each window is
 * wrapped in a "breath" element so its ambient drift animation doesn't
 * fight the WindowMock's own hover lift.
 */
export function Environment() {
  return (
    <section
      id="environment"
      className={styles.section}
      aria-labelledby="environment-title"
    >
      <div className={styles.surface} aria-hidden />

      <div className={`atlasContainer ${styles.inner}`}>
        <header className={styles.header}>
          <span className="atlasEyebrow">The Environment</span>
          <h2 id="environment-title" className={styles.title}>
            A digital desk.
          </h2>
          <p className={styles.lede}>
            Atlas Desk gives your tools a place to live together. Same chrome,
            same shortcuts, same calm. Open as many as you want — they share
            one rhythm.
          </p>
        </header>

        {/* Notes is the focal window, centered at full scale. Calculator
            (left) and Layouts (right) sit in "side" wrappers that apply
            a subtle scale-down + slight upward offset + 0.9 opacity, so
            they read as further away — depth via perspective trick
            without any 3D transform. Each window still has its own
            breath animation inside the wrapper. */}
        <div className={styles.stage}>
          <div className={styles.side}>
            <div className={styles.calcBreath}>
              <WindowMock title="CALCULATOR" iconSvg={APP_ICONS.calculator}>
                <div className={styles.calcDisplay}>
                  <span className={styles.calcExpr}>12 + 8 × 4</span>
                  <span className={styles.calcResult}>44</span>
                </div>
                <div className={styles.calcKeys} aria-hidden>
                  <span className={styles.calcKey}>7</span>
                  <span className={styles.calcKey}>8</span>
                  <span className={styles.calcKey}>9</span>
                  <span className={`${styles.calcKey} ${styles.calcKeyOp}`}>
                    ×
                  </span>
                  <span className={styles.calcKey}>4</span>
                  <span className={styles.calcKey}>5</span>
                  <span className={styles.calcKey}>6</span>
                  <span className={`${styles.calcKey} ${styles.calcKeyOp}`}>
                    −
                  </span>
                  <span className={styles.calcKey}>1</span>
                  <span className={styles.calcKey}>2</span>
                  <span className={styles.calcKey}>3</span>
                  <span className={`${styles.calcKey} ${styles.calcKeyEq}`}>
                    =
                  </span>
                </div>
              </WindowMock>
            </div>
          </div>

          <div className={styles.notesBreath}>
            <WindowMock title="NOTES" iconSvg={APP_ICONS.notes}>
              <p className={styles.notesHeading}>Saturday planning</p>
              <ul className={styles.notesList}>
                <li>Coffee at the spot by the park</li>
                <li>Pick up film from the lab</li>
                <li>Frame the print Mira sent</li>
                <li className={styles.notesDone}>Finish the layout sketch</li>
              </ul>
            </WindowMock>
          </div>

          <div className={styles.side}>
            <div className={styles.layoutsBreath}>
              <WindowMock
                title="LAYOUTS"
                iconSvg={APP_ICONS.layouts}
                bodyPadding="flush"
              >
                <div className={styles.layoutGrid} aria-hidden>
                  <span
                    className={styles.layoutTile}
                    style={{ gridArea: "a" }}
                  />
                  <span
                    className={styles.layoutTile}
                    style={{ gridArea: "b" }}
                  />
                  <span
                    className={`${styles.layoutTile} ${styles.layoutTileAccent}`}
                    style={{ gridArea: "c" }}
                  />
                  <span
                    className={styles.layoutTile}
                    style={{ gridArea: "d" }}
                  />
                </div>
              </WindowMock>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
